// extracted by mini-css-extract-plugin
export var activityContainer = "_go-0";
export var typingIndicatorContainer = "_go-1";
export var typingIndicatorDot = "_go-2";
export var wave = "_go-3";